import { render, staticRenderFns } from "./Landing2ApproachMobile.vue?vue&type=template&id=03985f23&scoped=true"
import script from "./Landing2ApproachMobile.vue?vue&type=script&lang=js"
export * from "./Landing2ApproachMobile.vue?vue&type=script&lang=js"
import style0 from "./Landing2ApproachMobile.vue?vue&type=style&index=0&id=03985f23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03985f23",
  null
  
)

export default component.exports